// extracted by mini-css-extract-plugin
export default {"table":"Board_table__ukbq1","square":"Board_square__TgeBh","blocked":"Board_blocked__o-eOo"};